export function appDownload() {
  return 'https://d.lifevc.com/';
}
